import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { Flexi } from "../models/flexi";
import { FlexiServices } from "./flexi.services";
import { BaseServices } from "../../kuba.services";



@Injectable()
export class FlexiResolver {
    constructor(private backend: FlexiServices) { }
    resolve(route: ActivatedRouteSnapshot) {
        return this.backend.getAdvisor(BaseServices.BusinessId);
    }
}
@Injectable()
export class OHSDataResolver {
    constructor(private backend: FlexiServices) { }
    resolve(route: ActivatedRouteSnapshot) {
        return this.backend.getOHSdata(BaseServices.BusinessId);
    }
}